import { render, staticRenderFns } from "./TaskManagement.vue?vue&type=template&id=17ac87f4&scoped=true&"
import script from "./TaskManagement.vue?vue&type=script&lang=js&"
export * from "./TaskManagement.vue?vue&type=script&lang=js&"
import style0 from "./TaskManagement.vue?vue&type=style&index=0&id=17ac87f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ac87f4",
  null
  
)

export default component.exports